module.exports = __webpack_public_path__ + "static/media/monthlySales.8d340eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/monthlySales.png
// module id = 271
// module chunks = 0